import { render } from "./Painel.vue?vue&type=template&id=1e4f73b8"
import script from "./Painel.vue?vue&type=script&lang=js"
export * from "./Painel.vue?vue&type=script&lang=js"

import "./Painel.vue?vue&type=style&index=0&id=1e4f73b8&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__